import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type Styles = {
  select: CSSProperties;
  selectIcon: CSSProperties;
};

const styles: Styles = {
  select: {
    width: '100%'
  },
  selectIcon: {
    fontSize: '18px',
    color: AppColors.VA.PRIMARY._50_
  }
};

export default styles;
